// extracted by mini-css-extract-plugin
module.exports = {"city-tag-duration":"CityTagDuration_city-tag-duration__IlkVL"};